var path = 'msi/shipments/send-shipment-now/views/send-shipment-now-button.html';
var html = "<button type=\"button\" class=\"og-primary\" ng-click=\"$ctrl.sendShipmentNow($ctrl.shipment)\">\n  {{'SHIPMENT_SEND_NOW_BUTTON' | translate}}\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;